import { Inject, Injectable } from '@angular/core';

import type { ApiClient } from '@packages/shared-utils';
import { API_CLIENT } from './api-client.provider';
import type { ApiProvider } from './api.types';

@Injectable({ providedIn: 'root' })
export class ProvidersApiService {
  constructor(@Inject(API_CLIENT) private readonly api: ApiClient) {}

  create(payload: {
    name: string;
    contact_name?: string | null;
    phone?: string | null;
    secondary_phone?: string | null;
    email?: string | null;
    city_codes?: string[];
    preferred_contact_method?: string | null;
    internal_notes?: string | null;
    admin_notes?: string | null;
    languages?: string[];
    insurance_verified?: boolean;
    wcb_registered?: boolean;
    trust_status?: 'trusted' | 'caution' | 'pre_block' | 'blocked' | null;
    working_hours?: Record<string, { open: boolean; from?: string; to?: string }> | null;
    category_ids?: string[];
    is_active?: boolean;
  }): Promise<ApiProvider> {
    return this.api.post<ApiProvider>('/providers', payload);
  }

  update(
    id: string,
    payload: {
      name?: string;
      contact_name?: string | null;
      phone?: string | null;
      secondary_phone?: string | null;
      email?: string | null;
      city_codes?: string[];
      preferred_contact_method?: string | null;
      internal_notes?: string | null;
      admin_notes?: string | null;
      languages?: string[];
      insurance_verified?: boolean;
      wcb_registered?: boolean;
      trust_status?: 'trusted' | 'caution' | 'pre_block' | 'blocked' | null;
        working_hours?: Record<string, { open: boolean; from?: string; to?: string }> | null;
      category_ids?: string[];
      is_active?: boolean;
    },
  ): Promise<ApiProvider> {
    return this.api.patch<ApiProvider>(`/providers/${encodeURIComponent(id)}`, payload);
  }

  getById(id: string): Promise<ApiProvider> {
    return this.api.get<ApiProvider>(`/providers/${encodeURIComponent(id)}`);
  }

  list(opts?: {
    cityCodes?: string[];
    categoryIds?: string[];
    search?: string;
    trustStatus?: string;
    insuranceVerified?: 'true' | 'false';
    isActive?: 'true' | 'false';
  }): Promise<{ items: ApiProvider[]; recommended_provider_id: string | null }> {
    const params = new URLSearchParams();
    if (opts?.cityCodes?.length)    params.set('cityCodes',    opts.cityCodes.join(','));
    if (opts?.categoryIds?.length)  params.set('categoryIds',  opts.categoryIds.join(','));
    if (opts?.search)               params.set('search',       opts.search);
    if (opts?.trustStatus)          params.set('trustStatus',  opts.trustStatus);
    if (opts?.insuranceVerified)    params.set('insuranceVerified', opts.insuranceVerified);
    if (opts?.isActive)             params.set('isActive',     opts.isActive);
    const qs = params.toString() ? `?${params.toString()}` : '';
    return this.api.get<{ items: ApiProvider[]; recommended_provider_id: string | null }>(
      `/providers${qs}`,
    );
  }
}